export const selectPeople = (people) => {
  const options = [];
  people.forEach((person) => {
    options.push({
      label: person.name,
      value: person.label,
    });
  });
  return options;
};

export const getNonEmptyPeople = (people) => {
  return people.slice().filter((person) => {
    return person.id || person.name || person.function || person.label;
  });
};



// WEBPACK FOOTER //
// ./services/selectPeople.js